module.exports = __webpack_public_path__ + "img/French.327f82a7.svg";